import script from "./LocaleSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./LocaleSelector.vue?vue&type=script&setup=true&lang=js"

import "./LocaleSelector.vue?vue&type=style&index=0&id=37c21b9b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37c21b9b"]])

export default __exports__